import { render, staticRenderFns } from "./index.vue?vue&type=template&id=faf2c8ee&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=faf2c8ee&prod&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=faf2c8ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf2c8ee",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/about/about-dialog/index.vue
// module id = null
// module chunks = 